import React, { useMemo } from 'react';

export type RingProps = {
  size?: number | string;
  strokeWidth?: number | string;
  rate?: number; // 百分比数字
  strokeColor?: string;
  contrastStrokeColor?: string;
  className?: string;
};

const Ring: React.FC<RingProps> = ({
  size = 100,
  strokeWidth = 5,
  rate = 0,
  strokeColor = '#f75c2f',
  contrastStrokeColor = '#ccc',
  className,
}) => {
  const cx = useMemo(() => +size / 2, [size]);
  const cy = useMemo(() => +size / 2, [size]);
  const r = useMemo(() => +size / 2 - +strokeWidth, [size, strokeWidth]);
  const strokeDasharray = useMemo(() => {
    const perimeter = Math.PI * 2 * r;
    const showLength = (rate / 100) * perimeter;
    return `${showLength} 1000`;
  }, [r, rate]);
  const transform = useMemo(() => `matrix(0,-1,1,0,0,${size})`, [size]);
  return (
    <svg width={size} height={size} className={className}>
      <circle cx={cx} cy={cy} r={r} strokeWidth={strokeWidth} stroke={contrastStrokeColor} fill="none" />
      {!!rate && (
        <circle
          cx={cx}
          cy={cy}
          r={r}
          strokeWidth={strokeWidth}
          stroke={strokeColor}
          fill="none"
          transform={transform}
          strokeDasharray={strokeDasharray}
          strokeLinecap="round"
        />
      )}
    </svg>
  );
};

export default Ring;
